import React, { useState } from 'react';
import { Maximize2 } from 'lucide-react';

const Tile = ({ img, index, onOpen, featured = false }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <button
      type="button"
      onClick={() => onOpen(index)}
      data-testid={`gallery-tile-${index + 1}`}
      aria-label={`Open photograph ${index + 1}`}
      className={`group relative block w-full overflow-hidden bg-[#E9DCC6] text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#B8884A] ${featured ? '' : 'mb-4 md:mb-5 break-inside-avoid'}`}
      style={{ aspectRatio: `${img.w} / ${img.h}` }}
    >
      <img
        src={featured ? img.src : img.thumb}
        srcSet={featured ? undefined : `${img.thumb} 900w, ${img.src} 2000w`}
        sizes={featured ? '100vw' : '(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw'}
        alt={`AdAura Awards 2026 — awards night photograph ${index + 1}`}
        loading={featured ? 'eager' : 'lazy'}
        decoding="async"
        onLoad={() => setLoaded(true)}
        className={`absolute inset-0 h-full w-full object-contain transition-[opacity,transform] duration-700 ease-out ${loaded ? 'opacity-100' : 'opacity-0'} group-hover:scale-[1.025]`}
      />
      <span aria-hidden className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#120B07]/55 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      <span aria-hidden className="pointer-events-none absolute bottom-4 left-4 flex items-center gap-2 text-[10px] tracking-[0.32em] uppercase text-[#F7F0E4] opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
        <Maximize2 size={12} /> {String(index + 1).padStart(2, '0')}
      </span>
    </button>
  );
};

export default Tile;
